// seconds-to-days.pipe.ts
import { Pipe, PipeTransform, inject } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { DateTimeHelper } from '../../features/calendar/util/date-time-helper';

@Pipe({
  name: 'timeFormat',
  standalone: true,
})
export class TimeFormatPipe implements PipeTransform {
  private readonly decimalPipe = inject(DecimalPipe);
  transform(secondsOrHours: number, formatType: TimeFormatType): string {
    if (secondsOrHours === null) {
      return '';
    }

    if (formatType === TimeFormatType.HoursToHoursAndMinutes) {
      if (isNaN(secondsOrHours)) {
        return '--:--';
      }
      const hh = secondsOrHours.toString().padStart(2, '0');
      return `${hh}:00 h`;
    }

    if (formatType === TimeFormatType.SecondsToHoursAndMinutesAndSeconds) {
      const totalSeconds = secondsOrHours;
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      return [hours, minutes, seconds].map((v) => String(v).padStart(2, '0')).join(':');
    }

    // Format the date as decimal
    if (formatType === TimeFormatType.SecondsToDaysDecimal) {
      const days = secondsOrHours / 86400;
      // Use Angular's DecimalPipe to format the decimal number.
      const formattedDays = this.decimalPipe.transform(days, '1.0-2', 'de');
      return `${formattedDays}`;
    }

    if (formatType === TimeFormatType.SecondsToHoursAndMinutes) {
      return `${DateTimeHelper.formatSecondsToHoursAndMinutes(secondsOrHours)} h`;
    }

    return secondsOrHours.toString();
  }
}

export enum TimeFormatType {
  SecondsToDaysDecimal,
  SecondsToHoursAndMinutes,
  SecondsToHoursAndMinutesAndSeconds,
  HoursToHoursAndMinutes,
}
